module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./DeconvolutionQueryView.js"));
	}, "PersonalAchieveView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PersonalAchieveView!./src/pages/Promote/Achievement/DeconvolutionQuery/DeconvolutionQueryView.js
// module id = 1661
// module chunks = 418